import React from "react";
import classNames from "classnames";

import CustomSection from "../../custom-general/custom-section";
import PDFTablePage from "../../../themed/pdf/pdfTablePage";

import { Column } from "../../../../utils/models";
import { formatTime } from "../../../../utils/utilities";
import { APP_DATE_FORMAT } from "../../../../utils/constants";
import { TOFDScanPlanItem } from "../tofdScanPlanItems";

import styles from './style.module.scss';

interface Props {
    tofdPlanItems: TOFDScanPlanItem[];
}

const TOFDPlan: React.FC<Props> = ({ tofdPlanItems }) => {
    return ( 
        <>
            {tofdPlanItems.map((tofdItem) => (
                <CustomSection key={tofdItem.id} sectionTitle="Scan Plan">
                    <div className={classNames(["p-1", styles.summary])}>
                        <PDFTablePage 
                            data={[tofdItem]} 
                            columns={FIRST_TABLE} 
                        />

                        <div className="mt-1">
                            <PDFTablePage 
                                data={[tofdItem]} 
                                columns={SECOND_TABLE} 
                            />
                        </div>
                       
                        <div className="mt-1">
                            <PDFTablePage 
                                data={[tofdItem]} 
                                columns={THIRD_TABLE} 
                            />
                        </div>

                        <div className={classNames(["p-1", styles.summaryImage])}>
                            <img src={tofdItem.images[0].src} alt={tofdItem.images[0].caption} />
                        </div>
                    </div>
                </CustomSection>
            ))}
        </>
     );
};

const FIRST_TABLE: Column[] = [
    {
        path: 'wallThickness',
        label: 'WALL THICKNESS (mm)',
    },
    {
        path: 'bevelAngle',
        label: 'BEVEL ANGLE',
    },
    {
        path: 'weldBevelShape',
        label: 'WELD BEVEL SHAPE',
    },
    {
        path: 'weldCondition',
        label: 'WELD CONDITION',
    },
    {
        path: 'scanType',
        label: 'SCAN TYPE',
    },
];

const SECOND_TABLE: Column[]  = [
    {
        path: 'materialType',
        label: 'TYPE OF MATERIAL',
    },
    {
        path: 'probeAngle',
        label: 'PROBE ANGLE (deg)',
    },
    {
        path: 'probeSerialNumber',
        label: 'PROBE SERIAL NUMBER',
    },
    {
        path: 'calibrationBlockThickness',
        label: 'CALIBRATION BLOCK THICKNESS (mm)',
    },
    {
        path: 'scanSide',
        label: 'SCAN SIDE',
    },
];

const THIRD_TABLE: Column[] = [
    {
        path: 'equipmentModal',
        label: 'EQUIPMENT MODAL',
    },
    {
        path: 'equipmentSerialNumber',
        label: 'EQUIPMENT SERIAL NUMBER',
    },
    {
        path: 'equipmentCalibrationDate',
        label: 'EQUIPMENT CALIBRATION DATE',
        content: (item) => <span>{formatTime(item.equipmentCalibrationDate, APP_DATE_FORMAT)}</span>
    },
    {
        path: 'referenceDB',
        label: 'REFERENCE dB',
    },
    {
        path: 'inspectionDate',
        label: 'INSPECTION DATE',
        content: (item) => <span>{formatTime(item.inspectionDate, APP_DATE_FORMAT)}</span>
    },
];
 
export default TOFDPlan;